<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useDashboardNavTour } from '@/composables/useDashboardNavTour'
import { useDashboardNotifications } from '@/composables/useDashboardNotifications'
import { useDashboardWelcomeWizard } from '@/composables/useDashboardWelcomeWizard'
import SwiftyLottie from '@/components/dashboard/ui/SwiftyLottie.vue'

const { t } = useI18n()
const { startNavTour } = useDashboardNavTour()
const { showWelcomeNotification } = useDashboardNotifications()
const { dismissWelcomePermanently } = useDashboardWelcomeWizard()

const onTakeTour = () => {
  startNavTour()
}

const onDismiss = () => {
  dismissWelcomePermanently()
}
</script>

<template>
  <section
    v-if="showWelcomeNotification"
    class="sa-welcome-notification"
    aria-labelledby="dashboard-welcome-notification-title"
  >
    <div class="sa-welcome-notification__glow" aria-hidden="true" />
    <div class="sa-welcome-notification__content">
      <div class="sa-welcome-notification__visual" aria-hidden="true">
        <SwiftyLottie class="sa-welcome-notification__swifty" />
      </div>
      <div class="sa-welcome-notification__body">
        <h3 id="dashboard-welcome-notification-title" class="sa-welcome-notification__title">
          {{ $t('Dashboard.Welcome.Notification.Title') }}
        </h3>
        <p class="sa-welcome-notification__text">
          {{ $t('Dashboard.Welcome.Notification.Body') }}
        </p>
        <div class="sa-welcome-notification__actions">
          <button
            type="button"
            class="sa-btn-primary sa-btn-primary--compact sa-welcome-notification__cta"
            @click="onTakeTour"
          >
            {{ $t('Dashboard.Welcome.Notification.Cta') }}
          </button>
          <button
            type="button"
            class="sa-welcome-notification__later"
            @click="onDismiss"
          >
            {{ $t('Dashboard.Welcome.Notification.Later') }}
          </button>
        </div>
      </div>
    </div>
    <button
      type="button"
      class="sa-welcome-notification__close"
      :aria-label="t('Dashboard.Welcome.Notification.DismissAria')"
      @click="onDismiss"
    >
      ✕
    </button>
  </section>
</template>
